import React from 'react';
import Spinner from '../spinner/Spinner';

export default function LoaderComponent({ ...props }) {
  return (
    <article className="row pull-left" {...props}>
      <Spinner />
    </article>
  );
}
